import {
  SET_DATA,
  SET_TASKS,
  SET_PROJECTPLAN,
  SET_INVOICES,
  SET_ATTACHMENTS,
  SET_TRIAGE,
  DataActionType,
} from "./types";

export const setData = (data: any): DataActionType => ({
  type: SET_DATA,
  data,
});

export const setTasks = (data: any): DataActionType => ({
  type: SET_TASKS,
  data,
});

export const setProjectPlan = (data: any): DataActionType => ({
  type: SET_PROJECTPLAN,
  data,
});

export const setInvoices = (data: any): DataActionType => ({
  type: SET_INVOICES,
  data,
});

export const setAttachments = (data: any): DataActionType => ({
  type: SET_ATTACHMENTS,
  data,
});

export const setTriage = (data: any): DataActionType => ({
  type: SET_TRIAGE,
  data,
});
